import { useState } from 'react';

/**
 * Word cloud input for Menti participants.
 * Text input where users type words (limited by maxWords).
 *
 * @param {Object} props
 * @param {Object} props.slide - Slide data with config.maxWords
 * @param {function} props.onSubmit - Called with the word(s) string
 * @param {boolean} props.loading
 */
export default function WordCloudInput({ slide, onSubmit, loading }) {
  const [value, setValue] = useState('');
  const maxWords = slide.config?.maxWords || 3;

  const wordCount = value.trim() ? value.trim().split(/\s+/).length : 0;
  const isOverLimit = wordCount > maxWords;

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || isOverLimit || loading) return;
    onSubmit(trimmed);
  };

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 border border-white/15">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <label className="sr-only" htmlFor="wordcloud-input">Skriv eit ord</label>
        <input
          type="text"
          id="wordcloud-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Skriv eit ord..."
          className="block w-full bg-white text-gray-900 placeholder:text-gray-400 rounded-full border-0 focus:ring-4 focus:ring-blue-300/30 h-14 text-lg font-medium px-6 shadow-inner transition-all duration-200"
          disabled={loading}
          autoComplete="off"
          autoFocus
        />

        <p className={`text-sm text-center ${isOverLimit ? 'text-red-300 font-medium' : 'text-white/50'}`}>
          Maks {maxWords} ord {wordCount > 0 && `(${wordCount}/${maxWords})`}
        </p>

        <button
          type="submit"
          disabled={!value.trim() || isOverLimit || loading}
          className="w-full h-12 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 hover:brightness-110 active:translate-y-0 transition-all duration-200 disabled:opacity-40 disabled:hover:translate-y-0 disabled:hover:shadow-lg flex items-center justify-center gap-2"
        >
          {loading ? (
            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <>
              <span>Send</span>
              <span className="material-symbols-outlined text-xl">send</span>
            </>
          )}
        </button>
      </form>
    </div>
  );
}
